export var PastePluginActionTypes = /*#__PURE__*/function (PastePluginActionTypes) {
  PastePluginActionTypes["START_TRACKING_PASTED_MACRO_POSITIONS"] = "START_TRACKING_PASTED_MACRO_POSITIONS";
  PastePluginActionTypes["STOP_TRACKING_PASTED_MACRO_POSITIONS"] = "STOP_TRACKING_PASTED_MACRO_POSITIONS";
  PastePluginActionTypes["ON_PASTE"] = "ON_PASTE";
  return PastePluginActionTypes;
}({});